import { pageIds } from "./contants";

export const navMenus = [
  {
    text: "Home",
    link: `#${pageIds.home}`,
  },
  {
    text: "Experience",
    link: `#${pageIds.experience}`,
  },
  {
    text: "Skills",
    link: `#${pageIds.skills}`,
  },
  {
    text: "Projects",
    link: `#${pageIds.projects}`,
  },
  {
    text: "Teams",
    link: `#${pageIds.teams}`,
  },
  {
    text: "contactUs",
    link: `#${pageIds.contactUs}`,
  },
];
